import { $, $$, isTablet } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-co2-calculator]')) return;

  addEventListeners();
}

function addEventListeners() {
  $$('[data-au-co2-calculator-card]').forEach((card) => {
    card.addEventListener('click', co2ToggleSelection);
  });

  $$('[data-au-co2-calculator-inputs-row]').forEach((row) => {
    co2Calculation(row);
  });

  $$('[data-au-co2-calculator-toggle-breakdown]').forEach((el) => {
    co2ToggleBreakdown(el);
  });

  co2AppendInputs();
  isTablet.addEventListener('change', co2AppendInputs);
}

function co2AppendInputs() {
  const cardElements = document.querySelectorAll('[data-au-co2-calculator-group-selection-card]');
  const dataBElements = document.querySelectorAll('[data-au-co2-calculator-inputs-row]');

  // Remove previously appended elements first
  cardElements.forEach((card) => {
    const appendedElements = card.querySelectorAll('[data-au-co2-calculator-inputs-row]');
    appendedElements.forEach((el) => el.remove());
  });

  // Check if the viewport width is below 1024px
  if (isTablet.matches) {
    // Move original elements instead of cloning, and remove them from their original location
    dataBElements.forEach((element, index) => {
      if (cardElements[index]) {
        cardElements[index].appendChild(element);
      }
    });
  } else {
    // Restore original elements back to their original parent container
    const originalParent = document.querySelector('[data-au-co2-calculator-inputs-block]');
    if (originalParent) {
      dataBElements.forEach((element) => {
        originalParent.appendChild(element);
      });
    }
  }
}

/**
 * Function to show
 *
 * @param e
 */
function co2ToggleSelection(e) {
  const card = e.currentTarget;
  const id = card.getAttribute('aria-controls');
  const target = $(`#${id}`);
  const inputsBox = $('[data-au-co2-calculator-inputs-block]');
  const fieldset = card.closest('[data-au-co2-calculator-selection]');
  const checkedInputsLength = fieldset.querySelectorAll('input:checked').length;

  if (checkedInputsLength > 0) {
    inputsBox.classList.remove('au-hide');
  } else {
    inputsBox.classList.add('au-hide');
    $('[data-au-co2-calculator-summary-breakdown]').classList.add('au-hide');
    $('[data-au-co2-calculator-summary-main]').classList.add('au-hide');
    $('[data-au-co2-calculator-summary-equivalences]').classList.add('au-hide');
    $('[data-au-co2-calculator-summary-intro]').classList.remove('au-hide');
  }

  co2ResetDataPerVehicle(target);

  // datalayer
  if (card.querySelector('input:checked')) {
    const inputsChecked = [];
    fieldset.querySelectorAll('input:checked').forEach((input) => {
      const inputsText = input.closest('[data-au-checkbox]').querySelector('label').textContent;
      inputsChecked.push(inputsText.trim());
    });

    const titleText = card.closest('[data-au-co2-calculator]').querySelector('[data-au-title]').textContent;
    const item_id = `${removeAccentMarkAndUppercase(titleText)}_${removeAccentMarkAndUppercase(inputsChecked.join('_'))}`;

    window.dataLayer.push({
      event: 'navigation',
      content_type: 'clickModulo',
      item_id,
    });
  }
}

function co2ResetDataPerVehicle(target) {
  const targetInputs = target.querySelector('[data-au-co2-calculator-inputs]');
  const targetInputsId = targetInputs.dataset.auCo2CalculatorInputs;
  const vehicleResult = $(`[data-au-co2-calculator-vehicle-res="${targetInputsId}"]`).closest(
    '[data-au-co2-calculator-summary-vehicle]',
  );

  target.querySelectorAll('input').forEach((input) => {
    input.value = '';
  });

  target.classList.toggle('au-hide');
  vehicleResult.classList.toggle('au-hide');
  if (!$(`[aria-controls="${target.dataset.auCo2CalculatorInputsRow}"] input:checked`)) {
    vehicleResult.querySelector('[data-au-co2-calculator-vehicle-res]').textContent = '0';
  }
}

function co2UpdateTotalCO2(e) {
  const emissionFactor = e.currentTarget.closest('[data-au-co2-calculator-inputs-gasoline]') ? 2.973 : 2.944;
  const oilDensity = e.currentTarget.closest('[data-au-co2-calculator-inputs-gasoline]') ? 0.752 : 0.845;
  const inputsId = e.currentTarget.closest('[data-au-co2-calculator-inputs]').dataset.auCo2CalculatorInputs;
  const resultPerVehicle = $(`[data-au-co2-calculator-vehicle-res="${inputsId}"]`);
  const numOfVehicles = resultPerVehicle
    .closest('[data-au-co2-calculator-summary-vehicle]')
    .querySelector('[data-au-co2-calculator-vehicle-num]');
  const numOfVehiclesInput = $(
    `[data-au-co2-calculator-inputs="${inputsId}"] [data-au-co2-calculator-input-vehicles] input`,
  ).value;

  if (numOfVehiclesInput && numOfVehiclesInput !== 0) {
    numOfVehicles.textContent = `x ${numOfVehiclesInput}`;
  } else {
    numOfVehicles.textContent = '';
  }

  const allInputs = e.currentTarget
    .closest('[data-au-co2-calculator-inputs]')
    .querySelectorAll('[data-au-co2-calculator-input] input');
  const values = Array.from(allInputs).map((input) => parseFloat(input.value) || NaN);
  const totalCo2 = $('[data-au-co2-calculator-total-co2]');
  const totalVehicles = $('[data-au-co2-calculator-total-vehicles]');
  let totalco2PerVehicleSum = 0;
  let totalVehiclesSum = 0;

  if (values.every((val) => !isNaN(val))) {
    const [consumo, kmAnual, numVehiculos] = values;
    const rowCO2 = ((consumo * kmAnual) / 100) * numVehiculos * emissionFactor * oilDensity;
    resultPerVehicle.textContent = rowCO2.toFixed(2);
    // numsOfVehicle.textContent = rowCO2.toFixed(2);
    resultPerVehicle.closest('[data-au-co2-calculator-summary-vehicle]').classList.remove('au-hide');

    $('[data-au-co2-calculator-summary-intro]').classList.add('au-hide');
    if ($('[data-au-co2-calculator-summary-breakdown]').classList.contains('au-hide')) {
      $('[data-au-co2-calculator-summary-main]').classList.remove('au-hide');
      $('[data-au-co2-calculator-summary-equivalences]').classList.remove('au-hide');
    }
  } else {
    resultPerVehicle.textContent = 0;
    // numsOfVehicle.textContent = 0;
  }

  // Summatory of each total co2 per vehicle
  $$('[data-au-co2-calculator-vehicle-res]').forEach((co2PerVehicle) => {
    totalco2PerVehicleSum += parseFloat(co2PerVehicle.textContent);
  });

  $$('[data-au-co2-calculator-input-vehicles]').forEach((vehicles) => {
    const value = vehicles.querySelector('input').value;

    if (!isNaN(value) && value > 0) {
      totalVehiclesSum += parseFloat(value);
    }
  });

  // Update total CO₂ text
  totalCo2.textContent = co2FormatNumber(totalco2PerVehicleSum);
  totalVehicles.textContent = totalVehiclesSum;

  // Update equivalences
  const equivalences = calculateEquivalences(totalco2PerVehicleSum);
  $('[data-au-co2-calculator-trees]').textContent = co2FormatNumber(equivalences.trees);
  $('[data-au-co2-calculator-mobile-charges]').textContent = co2FormatNumber(equivalences.mobileCharges);
  $('[data-au-co2-calculator-kwh]').textContent = co2FormatNumber(equivalences.kwh);
  $('[data-au-co2-calculator-km]').textContent = co2FormatNumber(equivalences.km);
  $('[data-au-co2-calculator-flights]').textContent = co2FormatNumber(equivalences.flights);
}

function co2Calculation(row) {
  row.querySelectorAll('[data-au-co2-calculator-input] input').forEach((input) => {
    input.addEventListener('input', co2UpdateTotalCO2);
  });

  row.querySelectorAll('[data-au-float-input-clear]').forEach((clear) => {
    clear.addEventListener('click', co2UpdateTotalCO2);
  });
}

function co2ToggleBreakdown(el) {
  el.addEventListener('click', () => {
    $('[data-au-co2-calculator-summary-breakdown]').classList.toggle('au-hide');
    $('[data-au-co2-calculator-summary-main]').classList.toggle('au-hide');
  });
}

function co2FormatNumber(num) {
  const parts = num.toFixed(2).toString().split('.'); // Split integer and decimal parts
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'); // Add dots for thousands
  const formattedNumber = parts.join(','); // Ensure decimal separator is ','
  return formattedNumber.endsWith(',00') ? formattedNumber.slice(0, -3) : formattedNumber; // Remove ",00" if present
}

function calculateEquivalences(totalKgCo2) {
  const trees = totalKgCo2 / 22; // 1 tree absorbs approximately 22 kg of CO2 per year
  const mobileCharges = totalKgCo2 / 0.008; // 1 mobile charge emits approximately 0.008 kg of CO2
  const kwh = totalKgCo2 / 0.25; // 1 kWh of electricity generates approximately 0.25 kg of CO2
  const km = (kwh * 100) / 15; // Convert kWh to km assuming 15 kWh per 100 km
  const flights = totalKgCo2 / 1100; // 1 transatlantic flight emits approximately 1100 kg of CO2

  return {
    trees,
    mobileCharges,
    kwh,
    km,
    flights,
  };
}

export default { init };
